import { Link } from "@tanstack/react-router";
import { Sparkles } from "lucide-react";
import horizontalLogo from "@/assets/brand/logo-horizontal-mostrando-mexico.png.asset.json";
import compactLogo from "@/assets/brand/logo-horizontal-compacto.png.asset.json";
import verticalLogo from "@/assets/brand/logo-vertical-original.png.asset.json";
import brandIcon from "@/assets/brand/mostrando-mexico-icon.png.asset.json";
import darkVerticalLogo from "@/assets/brand/logo-vertical-fondo-oscuro.png.asset.json";
import darkHorizontalLogo from "@/assets/brand/logo-horizontal-fondo-oscuro.png.asset.json";

/**
 * Logotipo oficial: ícono + «Mostrando México». Los colores nunca cambian;
 * sobre fondos oscuros se usa la variante transparente original.
 * El lema «Tours · Experiencias» se oculta en celular.
 */
export function BrandLockup({ onPhoto = false, vertical = false, className = "" }: { onPhoto?: boolean; vertical?: boolean; className?: string }) {
  return (
    <Link to="/" aria-label="Mostrando México — inicio" className={`inline-flex min-w-0 items-center gap-2 ${className}`}>
      {onPhoto ? <picture className={vertical ? "brand-dark-footer-logo" : "brand-header-logo"}>
        {vertical && <source media="(max-width: 767px)" srcSet={darkHorizontalLogo.url} width={954} height={168} />}
        <img src={vertical ? darkVerticalLogo.url : darkHorizontalLogo.url} alt="Mostrando México — Tours · Experiencias" width={vertical ? 703 : 954} height={vertical ? 412 : 168} loading="lazy" decoding="async" />
      </picture> : vertical ? <img src={verticalLogo.url} alt="Mostrando México — Tours · Experiencias" width={800} height={800} className="brand-vertical-logo" loading="lazy" decoding="async" /> : <picture className="brand-header-logo">
        <source media="(max-width: 767px)" srcSet={compactLogo.url} width={720} height={120} />
        <img src={horizontalLogo.url} alt="Mostrando México — Tours · Experiencias" width={953} height={168} loading="eager" decoding="async" />
      </picture>}
    </Link>
  );
}

/** Ícono de Maya: el mismo ícono de la marca con borde dorado y distintivo de estrellitas. */
export function MayaMark({ size = 44, className = "" }: { size?: number; className?: string }) {
  return (
    <span className={`relative inline-grid shrink-0 place-items-center rounded-full bg-background ring-2 ring-gold ${className}`} style={{ width: size, height: size }}>
      <img src={brandIcon.url} alt="" className="h-[78%] w-[78%] object-contain" loading="eager" decoding="async" />
      <span className="absolute -right-1 -top-1 grid h-[42%] w-[42%] place-items-center rounded-full bg-gold text-foreground ring-2 ring-background">
        <Sparkles className="h-[70%] w-[70%]" aria-hidden />
      </span>
    </span>
  );
}
